module.exports = __webpack_public_path__ + "static/scale-model-of-sarah-p.-duke-gardens-in-durham-north-carolina-0a3312d59730f20670598ea87e858df5.png";